import { Directive, ElementRef, OnInit, Output, EventEmitter, Input } from '@angular/core';
import * as ol from 'openlayers';

@Directive({
  selector: '[lLmap]'
})
export class LmapDirective implements OnInit {

  private _lMap: ol.Map = null;

  @Input('lLmap')
  public lMapOptions: any;

  @Output()
  public onLoad: EventEmitter<any> = new EventEmitter();

  constructor(private _ele: ElementRef) {}

  ngOnInit(): void {
    this._initMap();
    this.onLoad.emit(this._lMap);
  }

  private _initMap() {
    this._lMap = new ol.Map(Object.assign({ target: this._ele.nativeElement }, this.lMapOptions));
  }

}
